import { useState, useEffect } from "react";
import Navigation from "../NavigationComponent/Navigation";
import TopNavigation from "../NavigationComponent/TopNavigation";
import MessagePopup from "../PopupComponent/MessagePopup";
import UploadIdaCert from "../UploadIdaCertComponent/UploadIdaCert";
import CertStoreService from "../../Services/CertStoreService";
import { ReactComponent as UploadIcon } from '../../Assets/img/Upload-primary-icon.svg';
import moment from "moment";

function IdaCertificate() {
    const [state, setState] = useState({
        model: null,
        success: false,
        message: "",
        certStatus: null
    });

    const loadCertStatus = () => {
        CertStoreService.getCert("IDA").then((response) => {
            setState((currentState) => ({
                ...currentState,
                certStatus: response.response
            }));
        }).catch(() => {
            setState((currentState) => ({
                ...currentState,
                certStatus: null
            }));
        });
    };

    useEffect(() => {
        loadCertStatus();
    }, []);

    const modelOpenHandler = (model) => {
        setState((currentState) => ({
            ...currentState,
            model: model
        }));
    }

    const modelCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            model: null
        }));
    }

    const messageDisplayHandler = (message) => {
        loadCertStatus();
        setState((currentState) => ({
            ...currentState,
            success: true,
            message: message
        }));
    }

    const messagePopupCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            success: false,
            message: null
        }));
    }

    return (
        <>
            <Navigation />
            <TopNavigation onPageReset={() => { }} />
            <div className="page-container">
                {state.success && <MessagePopup onClose={messagePopupCloseHandler} title="Success" body={state.message} />}
                {state.model == "upload-ida" && <UploadIdaCert onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} />}
                <div className="pagetop-container">
                    <div className="pagetop-buttons-container" style={{ justifyContent: "flex-end", width: "100%" }}>
                        <button type="button" className="secondary-button" onClick={() => modelOpenHandler("upload-ida")}>
                            <span className="secondary-button-icon"><UploadIcon /></span>
                            <span className="secondary-button-text">Upload IDA_FIR Certificate</span>
                        </button>
                    </div>
                </div>
                <div style={{ padding: '1% 3%' }}>
                    {state.certStatus ? (
                        <p>
                            Certificate present. Last updated: {moment(state.certStatus.modifiedDate || state.certStatus.createdDate).format('DD-MMM-YYYY')}
                        </p>
                    ) : (
                        <p>No IDA_FIR certificate uploaded yet.</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default IdaCertificate;
